import React from 'react'

import ItemTypeAndBookedLabel from '../Common/ItemTypeAndBookedLabel'
import StartAndEndLocation from '../Common/StartAndEndLocation'
import SummaryAdditionalNotes from '../Common/SummaryAdditionalNotes'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import AddressWithViewMapButton from 'tripPlanner/components/TripModal/TripItems/Summary/Common/AddressWithViewMapButton'
import CheckInAndOutDate from 'tripPlanner/components/TripModal/TripItems/Summary/Common/CheckInAndOutDate'
import { CruiseItem, TourItem } from 'tripPlanner/types/tripItem'
import { maybePlaceId } from 'tripPlanner/utils'

type Props = {
  item: CruiseItem | TourItem
}

const CustomItemSummaryContent = ({ item }: Props) => {
  const showDates =
    item.endDate || item.startDate || item.startDay || item.endDay
  const isPickAndDropTheSame =
    item.startPlace.address === item.endPlace?.address

  return (
    <ModalContent>
      <VerticalSpacer gap={20}>
        <ItemTypeAndBookedLabel item={item} />
        {showDates && (
          <CheckInAndOutDate
            isAccommodation={false}
            startDate={item.startDate}
            startDay={item.startDay}
            endDate={item.endDate}
            endDay={item.endDay}
            startTime={item.startTime}
            endTime={item.endTime}
          />
        )}
        {isPickAndDropTheSame && item.startPlace.address && (
          <AddressWithViewMapButton
            placeId={maybePlaceId(item.startPlace)}
            address={item.startPlace.address}
          />
        )}
        {!isPickAndDropTheSame && (
          <StartAndEndLocation
            startPlace={item.startPlace}
            endPlace={item.endPlace}
          />
        )}
        {item.url && (
          <div>
            <BodyText variant="small" weight="bold">
              Website
            </BodyText>
            <TextLink href={item.url} target="_blank" rel="nofollow">
              {item.url}
            </TextLink>
          </div>
        )}
        {item.price && (
          <div>
            <BodyText variant="small" weight="bold">
              Price
            </BodyText>
            <BodyText variant="large">{`$${item.price}`}</BodyText>
          </div>
        )}
        {item.confirmationCode && (
          <div>
            <BodyText variant="small" weight="bold">
              Confirmation number
            </BodyText>
            <BodyText variant="large">{item.confirmationCode}</BodyText>
          </div>
        )}
        {item.notes && <SummaryAdditionalNotes notes={item.notes} />}
      </VerticalSpacer>
    </ModalContent>
  )
}

export default CustomItemSummaryContent
